import { SsrService } from '@/common/services/ssr/ssr.service';
import { City } from '@/core/domain/address/models/cities-response.model';
import { CitiesResponse } from '@/core/domain/cities/models/cities.model';
import { GetCitiesUseCase } from '@/core/domain/cities/usecases/getCities.usecase';
import { DestinationsResponse } from '@/core/domain/destinations/models/destinations.model';
import { GetDestinationsUseCase } from '@/core/domain/destinations/usecases/getDestinations.usecase';
import { Component, OnInit } from '@angular/core';

export interface AccordionVisibility {
    [key: number]: boolean;
}

@Component({
    selector: 'fe-show-city-office-details',
    templateUrl: './show-city-office-details.component.html',
    styleUrls: ['./show-city-office-details.component.scss'],
})
export class ShowCityOfficeDetailsComponent implements OnInit {
    public destinations: DestinationsResponse | null = null;

    public cities: CitiesResponse | null = null;

    citiesGroup1: City[] = [];
    citiesGroup2: City[] = [];
    citiesGroup3: City[] = [];
    citiesGroup4: City[] = [];
    citiesGroup5: City[] = [];

    accordionVisibility: AccordionVisibility = {
        0: false,
        1: false,
    };

    isContainerVisible = false;

    constructor(
        private readonly getDestinationsUseCase: GetDestinationsUseCase,
        private readonly getCitiesUseCase: GetCitiesUseCase,
        public ssr: SsrService,
    ) {}

    ngOnInit(): void {
        this.getDestinations();
        this.getCities();
    }

    getDestinations(): void {
        this.getDestinationsUseCase.execute().subscribe((destinations) => {
            this.destinations = destinations;
        });
    }

    getCities(): void {
        this.getCitiesUseCase
            .execute()
            .subscribe((response: CitiesResponse) => {
                this.cities = response;

                if (response && response.data && response.data.cities) {
                    const sortedCities = response.data.cities.sort((a, b) =>
                        a.name.localeCompare(b.name),
                    );
                    const totalCities = sortedCities.length;

                    const groupSizeLg = Math.ceil(totalCities / 3);
                    const groupSizeMd = Math.ceil(totalCities / 2);

                    this.citiesGroup1 = sortedCities.slice(0, groupSizeLg);
                    this.citiesGroup2 = sortedCities.slice(
                        groupSizeLg,
                        groupSizeLg * 2,
                    );
                    this.citiesGroup3 = sortedCities.slice(
                        groupSizeLg * 2,
                        totalCities,
                    );

                    this.citiesGroup4 = sortedCities.slice(0, groupSizeMd);
                    this.citiesGroup5 = sortedCities.slice(
                        groupSizeMd,
                        totalCities,
                    );
                }
            });
    }

    getFormattedUrl(cityId: string | number): string {
        const baseUrl = 'destination-airport/{destinationId}/city';
        return baseUrl.replace('{destinationId}', cityId.toString());
    }

    toggleContainer(index: number): void {
        this.accordionVisibility[index] = !this.accordionVisibility[index];
    }
}
